import { useEffect, useRef } from 'react';
import type { RideImportChoice, XmlRideFormat } from '../domain/ride-import-choice';
import type { Ride } from '../domain/ride';
import './track-picker.css';

/** Modal selection keeps the currently open ride unchanged until a track is chosen. */
export function TrackPicker({ tracks, format = 'gpx', onSelect, onCancel }: {
  tracks: readonly RideImportChoice[] | null;
  format?: XmlRideFormat;
  onSelect: (ride: Ride) => void;
  onCancel: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (tracks) dialog.current?.showModal();
    else dialog.current?.close();
  }, [tracks]);
  return <dialog ref={dialog} className="track-picker" aria-labelledby="track-picker-title"
    onCancel={event => { event.preventDefault(); onCancel(); }}>
    <h2 id="track-picker-title">{format === 'tcx' ? 'Choose a recorded activity' : 'Choose a recorded track'}</h2>
    <p>{format === 'tcx' ? 'Open one activity from this TCX file.' : 'Open one track from this GPX file.'}</p>
    <ul>{tracks?.map(track => <li key={track.index}>
      <button type="button" disabled={!track.ride} onClick={() => track.ride && onSelect(track.ride)}>
        <strong>{track.title}</strong><span>{track.pointCount.toLocaleString()} points</span>
      </button>
      {track.error && <p>{track.error}</p>}
      {track.warnings?.map((warning, index) => <p key={index}>{warning}</p>)}
    </li>)}</ul>
    <button type="button" onClick={onCancel}>Cancel</button>
  </dialog>;
}
